export const paths = {
  RESET_EMAIL: 'reset.email',
  RESET_PASSWORD: 'reset.password',
  RESET_CONFIRM_PASSWORD: 'reset.confirmPassword'
};
